import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getmastereceactivitiydetailsThunk = createAsyncThunk(
  "eceactivity/getmasteractivitiydetailsThunk",
  async (params) => {
    const { usertype, clas, skill } = params;
    console.log(
      usertype,
      clas,
      skill,
      "usertype,slected_class,selected_themes"
    );
    let response = await api.get(
      "getEceActivityContents/" + usertype + "/" + clas + "/" + skill
    );
    return response.data;
  }
);

export const geteceactivityskillThunk = createAsyncThunk(
  "eceskillsetmanager/geteceactivityskill",
  async (clas) => {
    // const {  clas } = params;
    let response = await api.get("getAllEceSkills/" + clas);
    return response.data;
  }
);

export const createmastereceactivitiesThunk = createAsyncThunk(
  "eceactivity/createmasteractivitiesThunk",
  async (reqbody) => {
    const body = reqbody.body;
    let response = await api.post("/saveEceActivityContent", body);
    return response.data;
  }
);

export const updatemastereceactivitiesThunk = createAsyncThunk(
  "eceactivity/updatemasteractivitiesThunk",
  async (reqbody) => {
    const body = reqbody.updated_segments;
    console.log(body, "body");
    let response = await api.post("saveEceActivityContent/", body);
    return response.data;
  }
);

export const deleteEceContent = async (skillid) =>
  await api.delete(`deleteEceActivityContent/${skillid}`);
